import { useApiCommunicator } from '@btcdirect/shared/src/composables/api/communicator';
import { Endpoints } from '@btcdirect/shared/src/composables/api/endpoints';
import { useLogger } from '@btcdirect/shared/src/composables/util/logger';
import { usePartnerInfo } from '@btcdirect/shared/src/composables/util/partner-info';
import axios from 'axios';
import { DeepReadonly, readonly } from 'vue';

const { debug } = useLogger();

interface UserLoginResult {
    uuid: string;
    token: string;
    refreshToken: string;
}

interface UserLoginTokenResult {
    uuid: string;
    token: string;
    expiryDate: string;
}

export const useUserLogin = () => {
    const { post: loginPost } = useApiCommunicator(Endpoints.LOGIN);
    const { post: postOneTimeLogin } = useApiCommunicator(Endpoints.LOGIN_WITH_TOKEN);
    const { get } = useApiCommunicator(Endpoints.LOGIN_TOKEN);

    const login = (username: string, password: string): Promise<DeepReadonly<UserLoginResult>> => {
        return readonly(loginPost({ emailAddress: username, password: password }));
    };

    const getLoginToken = (): Promise<DeepReadonly<UserLoginTokenResult>> => {
        const { id: partnerId } = usePartnerInfo();
        let params = !!partnerId.value ? { apiClientId: partnerId.value} : null;
        return readonly(get(params));
    };

    const oneTimeLogin = async (token: string, uuid: string): Promise<UserLoginResult> => {
        return readonly(postOneTimeLogin({ token, uuid }));
    };

    // TODO: Remove this once MyBTC is a Vue project
    const logIntoMyBTC = async (): Promise<void> => {
        try {
            const loginToken = await getLoginToken();

            await axios.get('/widget/login', {
                params: {
                    token: loginToken.token,
                    uuid: loginToken.uuid,
                }
            });
        } catch (e) {
            debug(e);
        }
    };

    return {
        login,
        oneTimeLogin,
        getLoginToken,
        logIntoMyBTC
    };
};
